import { ChangeDetectionStrategy, Component, DestroyRef, inject, input, signal, viewChild } from '@angular/core';
import { SidebarSubnavComponent } from '../subnav/subnav.component';
import { SafeAreaComponent } from '../safe-area/safe-area.component';
import { TbsIconComponent } from '@ngx-terabase/ui/icon';

const CLOSE_DELAY_MS = 150;

@Component({
  selector: 'nav-item',
  templateUrl: './nav-item.component.html',
  styleUrl: './nav-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TbsIconComponent, SidebarSubnavComponent, SafeAreaComponent],
  host: {
    '(mouseenter)': 'onMouseEnter()',
    '(mouseleave)': 'onMouseLeave()',
  },
})
export class NavItemComponent {
  public readonly icon = input('');
  public readonly tag = input('');
  public readonly isSubnavItem = input(false);
  public readonly description = input('');
  public readonly inactive = input(false);
  public readonly haveSubnavigation = input(false);
  public readonly navTitle = input<string>();

  protected readonly open = signal(false);
  protected readonly submenuRef = viewChild(SidebarSubnavComponent);

  private closeTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    inject(DestroyRef).onDestroy(() => this.clearCloseTimeout());
  }

  protected onMouseEnter(): void {
    this.clearCloseTimeout();
    this.open.set(true);
  }

  protected onMouseLeave(): void {
    this.closeTimeout = setTimeout(() => {
      this.open.set(false);
      this.closeTimeout = null;
    }, CLOSE_DELAY_MS);
  }

  protected cancelClose(): void {
    this.clearCloseTimeout();
  }

  private clearCloseTimeout(): void {
    if (this.closeTimeout !== null) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
  }
}
